import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

function remainingTime(endsAt, now) {
  const ms = new Date(endsAt).getTime() - now;
  if (ms <= 0) return "ending";
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  return `${days}d ${hours}h ${minutes}m`;
}

export function SandsEaseEventPanel() {
  const [event, setEvent] = useState(null);
  const [busy, setBusy] = useState(false);
  const [now, setNow] = useState(Date.now());
  const load = useCallback(() => api.get("/admin/sands-ease-event").then((response) => setEvent(response.data)).catch(() => setEvent({ active: false })), []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { const timer = setInterval(() => setNow(Date.now()), 60000); return () => clearInterval(timer); }, []);

  const setActive = async (active) => {
    setBusy(true);
    try {
      const response = await api.post("/admin/sands-ease-event", { active });
      setEvent(response.data);
      toast.success(active ? "Sands Ease event started for seven days" : "Sands Ease event ended");
    } catch (error) {
      toast.error(apiErr(error));
    } finally {
      setBusy(false);
    }
  };

  return <section data-testid="sands-ease-event-panel" className={`mb-6 border p-4 rounded-sm ${event?.active ? "border-cyan-500/60 bg-cyan-950/20" : "border-amber-900/30 bg-zinc-950"}`}>
    <div className="flex flex-wrap items-center gap-3">
      <div className="min-w-[220px] flex-1">
        <h3 className="font-cinzel text-sm uppercase tracking-widest text-amber-300">Sands Ease Event</h3>
        <p data-testid="sands-ease-event-description" className="mt-1 text-sm text-zinc-400">Sands Run opponents are 10% weaker and every Legacy Sands reward is doubled, including armor finds. Expedition Kit reductions still stack multiplicatively.</p>
      </div>
      {event?.active ? <>
        <span data-testid="sands-ease-event-active-status" className="text-xs font-semibold text-cyan-200">Active · {remainingTime(event.active_until, now)} remaining</span>
        <button data-testid="sands-ease-event-stop-button" type="button" onClick={() => setActive(false)} disabled={busy} className="border border-red-900/50 px-4 py-2 text-sm text-red-300 transition-colors hover:border-red-500 disabled:opacity-50">End Event Now</button>
      </> : <button data-testid="sands-ease-event-start-button" type="button" onClick={() => setActive(true)} disabled={busy} className="bg-cyan-500 px-5 py-2 font-cinzel text-sm uppercase tracking-wide text-zinc-950 transition-colors hover:bg-cyan-400 disabled:opacity-50">Start 7-Day Event</button>}
    </div>
  </section>;
}